import { render, staticRenderFns } from "./BaseAddressSearch.vue?vue&type=template&id=66f0e3d9&scoped=true"
import script from "./BaseAddressSearch.vue?vue&type=script&lang=js"
export * from "./BaseAddressSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f0e3d9",
  null
  
)

export default component.exports